import DualRangeSlider from "@/routes/org/_components/table/filter/dual-slider"
import FilterPanel from "@/routes/org/_components/table/filter/filter-panel"
import { tableStore } from "../table-store"
import { langStore } from "@/stores/lang-store"
import { useParams } from "react-router-dom"
import React from "react"
import { useToggleStore } from "@/hooks/use-toggle-store"

const FILTER_LABELS = {
  leak_volume: { ko: "누수량", en: "Leak Volume" },
  usage_volume: { ko: "사용량", en: "Usage" },
  leak_rate: { ko: "누수율", en: "Leak Rate" },
  leak_type: { ko: "누수유형", en: "Leak Type" },
  leak_severity: { ko: "누수 심각도", en: "Leak Severity" },
  business_type: { ko: "업종명", en: "Business Type" },
  caliber: { ko: "구경 (mm)", en: "Diameter (mm)" }
}

const orgTableBundle = {
  filterLabels: FILTER_LABELS,
  mobileCardBundle: {
    toggle: {
      expand: { ko: "펼치기", en: "Expand" },
      collapse: { ko: "접기", en: "Collapse" }
    },
    labels: {
      sector: { ko: "업종", en: "Business Type" },
      diameter: { ko: "구경(mm)", en: "Diameter (mm)" },
      address: { ko: "주소", en: "Address" },
      leak_hours: { ko: "누수기간", en: "Leak Duration" }
    }
  }
}

const FilterControls = ({ headers }) => {
  const { lang } = langStore()
  const { org } = useParams()
  const { toggleFilter, initialRanges, setRangeFilter, filters, applyFilters, resetFilter } =
    tableStore()

  const rangeHeaders = headers.filter((h) => h.filter_type === "range")
  const enumHeaders = headers.filter((h) => h.filter_type === "enum" && h.enum)

  const { show, close } = useToggleStore("filter")

  return (
    <FilterPanel
      open={show}
      onClose={close}
      search={async () => await applyFilters(org)}
      reset={resetFilter}
    >
      {headers.length > 0 &&
        rangeHeaders.map((h) => (
          <React.Fragment key={h.key}>
            <h3 className="font-semibold mb-2">{h.label[lang]}</h3>
            <DualRangeSlider
              min={initialRanges?.[h.key]?.min ?? 0}
              max={initialRanges?.[h.key]?.max ?? 100}
              unit={h.label.unit[lang]}
              valueMin={filters.ranges?.[h.key]?.min ?? 0}
              valueMax={filters.ranges?.[h.key]?.max ?? 100}
              onChange={(v) => setRangeFilter(h.key, v)}
              precision={h.key === "leak_hours" ? 0 : 2}
            />
          </React.Fragment>
        ))}

      {headers.length > 0 &&
        enumHeaders.map((h) => (
          <React.Fragment key={h.key}>
            <h3 className="font-semibold mb-2">{orgTableBundle.filterLabels[h.key][lang]}</h3>
            <div className="flex gap-2 flex-wrap mb-4">
              {h.enum.map((v) => (
                <button
                  key={v}
                  onClick={() => toggleFilter(h.key, v)}
                  className={`
                    px-3 py-1 rounded-lg border cursor-pointer
                    ${
                      filters.enums?.[h.key].includes(v)
                        ? "bg-[#4b5985] text-white border-[#4b5985]"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-[#f2f4fa]"
                    }
                  `}
                >
                  {v}
                </button>
              ))}
            </div>
          </React.Fragment>
        ))}
    </FilterPanel>
  )
}

export default FilterControls
